import { FGIcon } from '@components/icons/FGIcon'
import { FlexRow } from '@components/shared/FlexRow'
import { CurrencyFormat, DecimalFormat, PercentFormat } from '@components/shared/Format'
import { FormField, SelectOption } from '@components/shared/FormField'
import { GoldCard } from '@components/shared/GoldCard'
import { I18n } from '@components/shared/I18n'
import { Table, TableCell, TableRow } from '@components/shared/Table'
import { CountryInfoUrlKey } from '@models/CountryInfo'
import { SectionComponent, SectionKey } from '@sections/SectionComponent'
import { StoreProps } from '@stores/Store'
import { I18nKey } from '@utils/i18n'
import { FqGrowthValue, frontlineGroupGrowthFqGrowthOptions, frontlineGroupGrowthLevelAchievedOptions, LevelAchievedValue } from '@utils/sections/FrontlineGrowthIncentive.util'
import { Form } from 'antd'
import { inject, observer } from 'mobx-react'
import React from 'react'

interface FrontlineGrowthIncentiveFormData {
  frontlineGrowthIncentiveLevelAchieved?: LevelAchievedValue
  frontlineGrowthIncentiveFqGrowth?: FqGrowthValue
}

@inject('store')
@observer
export class FrontlineGrowthIncentiveSection extends SectionComponent<StoreProps, {}> {
  static defaultProps = {} as StoreProps
  static get title(): I18nKey { return 'SECTION_FRONTLINE_GROWTH_INCENTIVE' }
  static get icon() { return <FGIcon /> }
  static get trackerKey() { return 'C+frontline' }

  onValuesChange = (data: FrontlineGrowthIncentiveFormData) => {
    const { store } = this.props
    const { frontlineGrowthIncentiveStore } = store
    if ('frontlineGrowthIncentiveLevelAchieved' in data) { frontlineGrowthIncentiveStore.setFrontlineGrowthIncentiveLevelAchieved(data.frontlineGrowthIncentiveLevelAchieved!) }
    if ('frontlineGrowthIncentiveFqGrowth' in data) { frontlineGrowthIncentiveStore.setFrontlineGrowthIncentiveFqGrowth(data.frontlineGrowthIncentiveFqGrowth!) }
    store.globalStore.updateSectionUsage(SectionKey.FRONTLINE_GROWTH_INCENTIVE)
  }

  render() {
    const { store } = this.props
    const { frontlineGrowthIncentiveStore } = store
    const { frontlineGrowthIncentive, frontlineGrowthIncentiveAnnualPPVRequirement, frontlineGrowthIncentiveAnnualRubyPVRequirement,
      frontlineGrowthIncentiveAnnualMultipier, frontlineGrowthIncentivePaymentCap } = store.frontlineGrowthIncentiveCalculation
    const { frontlineGrowthIncentiveLevelAchieved, frontlineGrowthIncentiveFqGrowth } = frontlineGrowthIncentiveStore
    const levelAchievedOptions: SelectOption<LevelAchievedValue>[] = frontlineGroupGrowthLevelAchievedOptions()
    const fqGrowthOptions: SelectOption<FqGrowthValue>[] = frontlineGroupGrowthFqGrowthOptions()

    return (
      <>
        <Form className='section' layout='vertical'
          initialValues={{ frontlineGrowthIncentiveLevelAchieved, frontlineGrowthIncentiveFqGrowth }}
          onValuesChange={this.onValuesChange}>
          <FlexRow collapse>
            <FormField name="frontlineGrowthIncentiveLevelAchieved" type='select' label='LEVEL_ACHIEVED_PY' options={levelAchievedOptions} />
            <FormField name="frontlineGrowthIncentiveFqGrowth" type='select' label='FQ_GROWTH' options={fqGrowthOptions} />
          </FlexRow>

        </Form>
        <Table className='section section-full-width'>
          <TableRow>
            <TableCell><I18n name='ANNUAL_PPV_REQUIREMENT' /></TableCell>
            <TableCell align='right'><DecimalFormat value={frontlineGrowthIncentiveAnnualPPVRequirement}></DecimalFormat></TableCell>
          </TableRow>
          <TableRow>
            <TableCell><I18n name='ANNUAL_RUBY_PV_REQUIREMENT' /></TableCell>
            <TableCell align='right'><DecimalFormat value={frontlineGrowthIncentiveAnnualRubyPVRequirement}></DecimalFormat></TableCell>
          </TableRow>
          <TableRow>
            <TableCell width={220}><I18n name='ANNUAL_MULTIPLIER_ON_LEADERSHIP' /></TableCell>
            <TableCell align='right'><PercentFormat value={frontlineGrowthIncentiveAnnualMultipier}></PercentFormat></TableCell>
          </TableRow>
          <TableRow>
            <TableCell><I18n name='PAYMENT_CAP' /></TableCell>
            <TableCell align='right'><CurrencyFormat value={frontlineGrowthIncentivePaymentCap}></CurrencyFormat></TableCell>
          </TableRow>
        </Table>
        <div className='section section-rewards'>
          {frontlineGrowthIncentive === 0 ? (
            <GoldCard title='CP_FRONTLINE_GROWTH_INCENTIVE_DISABLED' disabled infoContent='INFO_FRONTLINE_GROWTH_INCENTIVE' infoUrl={CountryInfoUrlKey.INFO_FRONTLINE_GROWTH_INCENTIVE_URL}></GoldCard>
          ) : (
            <GoldCard title='FRONTLINE_GROWTH' value={frontlineGrowthIncentive} period='PER_YEAR'></GoldCard>
          )}
        </div>
      </>
    )
  }
}

